import React from "react";
import HighD from "./result/HighD";
import HighS from "./result/HighS";
import HighI from "./result/HighI";
import HighC from "./result/HighC";
import CIS from "./result/CIS";
import IS from "./result/IS";

const ResultWrapper = ({ result }) => {
  if (result?.result?.result?.name === "Developer(توسع دهنده) High D") {
    return <IS testResult={result} />;
    // return <CIS testResult={result} />;
    // return <HighC testResult={result} />;
    // return <HighI testResult={result} />;
    // return <HighS testResult={result} />;
    // return <HighD testResult={result} />;
  }
};

export default ResultWrapper;
